import {
	ElButton,
	ElCarousel,
	ElCarouselItem,
	ElCheckbox,
	ElDivider,
	ElForm,
	ElIcon,
	ElInput,
	ElLink,
	ElMessage,
	ElNotification,
	ElOption,
	ElScrollbar,
	ElSelect,
	ElSkeleton,
	ElTabPane,
	ElTabs,
	FormRules,
	isEmpty,
	isNotEmpty,
	useForm,
} from '@qsxy/element-plus-react';
import { getWechatUrl, login, loginByPhone, monitorWechat } from './api';
import { useNavigate } from 'react-router-dom';
import { Iuser, ModalPageRef, Result } from '@/typings';
// import { setToken, setUser } from '@/redux/reducer';
import { useMount, useRequest } from 'ahooks';
import { getTime, setSessionData, setTime, setTokenInfo, setUserToken } from '@/auth/authUtil';
import { ACCESS_TOKEN, loginSlogon, sendFreuence } from '@/config';
import Cookies from 'js-cookie';
import React, { memo, useCallback, useMemo, useRef, useState } from 'react';
import './index.scss';
import { setUser } from '@/redux/reducer';
import { useDispatch } from 'react-redux';
import { sendVerificationCode } from '../register/api';
import { MOBILE_PATTERN } from '@/components/validatePatterns';
import BindWechat from './bindWechat';
// import loginImg1 from '@/assets/images/login1.webp';

export interface LoginData {
	token: string;
	user_menus: any[];
	user: Iuser;
}

const Login = () => {
	const [logining, setLogining] = useState(false);
	const [loginText, setLoginText] = useState('登录');
	const [invalidText, setInvalidText] = useState('二维码失效');

	const [formInstance] = useForm<{ username: string; password: string }>();
	const [formInstance1] = useForm<Iuser>();
	const dispatch = useDispatch();

	const timeOutRef = useRef(sendFreuence);
	const buttonRef = useRef<HTMLSpanElement>(null);
	const tryTimeRef = useRef(0);
	const timeRef = useRef(null);
	const dialogRef = useRef<ModalPageRef<any>>(null);

	const [disabled, setDisabled] = useState(false);
	// 二维码是否失效
	const [invalid, setInvalid] = useState(false);
	const [isAgree, setIsAgree] = useState(true);

	const navigate = useNavigate();

	const rules = useMemo<FormRules>(() => {
		return {
			phoneNumber: [
				{ required: true, message: '请填写手机号' },
				{ len: 11, message: '请填写11位长度手机号' },
				{ pattern: MOBILE_PATTERN, message: '手机号格式不正确' },
			],
			code: [{ required: true, message: '请填写验证码' }],
		};
	}, []);

	const startTimeout = () => {
		setDisabled(true);
		buttonRef.current.innerText = timeOutRef.current + 's';
		setTime(timeOutRef.current);
		const stop = setInterval(() => {
			timeOutRef.current = timeOutRef.current - 1;
			setTime(timeOutRef.current);
			if (timeOutRef.current <= 0) {
				timeOutRef.current = sendFreuence;
				setTime(sendFreuence);
				clearInterval(stop);
				setDisabled(false);
				buttonRef.current.innerText = '发送验证码';
			} else {
				buttonRef.current.innerText = timeOutRef.current + 's';
			}
		}, 1000);
	};

	const { runAsync } = useRequest(monitorWechat, {
		manual: true,
	});
	const {
		data = { sceneStr: '', ticket: '', expire: 0 },
		loading,
		refresh,
	} = useRequest(getWechatUrl, {
		onSuccess(result) {
			timeRef.current = setInterval(() => {
				if (tryTimeRef.current * 3 >= result.expire) {
					tryTimeRef.current = 0;
					if (timeRef.current) {
						clearInterval(timeRef.current);
						setInvalid(true);
					}
				} else {
					runAsync(result.sceneStr).then(res => {
						if (res == null) {
							//未扫描不处理
						}
						// 用户未注册或未绑定该微信号
						else if (res.status == 404) {
							clearInterval(timeRef.current);
							setInvalid(true);
							setInvalidText('已扫码');
							dialogRef.current.open(res.openId);
						} else if (res.status == 200) {
							clearInterval(timeRef.current);
							setInvalid(true);
							setInvalidText('已扫码');

							setTimeout(() => {
								const { token, user } = res;
								setUserToken();
								setSessionData(res);
								setTokenInfo(token);
								dispatch(setUser(user));
								navigate('/chat');
							}, 500);
						}
					});
					tryTimeRef.current = tryTimeRef.current + 1;
				}
			}, 3000);
		},
	});

	const onTabChange = (name: string) => {
		if (name !== 'wechat') {
			clearInterval(timeRef.current);
		} else {
			refresh();
		}
	};

	useMount(() => {
		const time = getTime() || sendFreuence;
		timeOutRef.current = Number(time);
		if (timeOutRef.current != sendFreuence) {
			startTimeout();
		}
		const ele = document.getElementById('loading');
		if (ele) {
			ele.parentNode.removeChild(ele);
		}
		Cookies.remove(ACCESS_TOKEN);
	});

	const onLogin = useCallback(() => {
		formInstance.validateFields().then(values => {
			if (isEmpty(values.username)) {
				ElMessage.warning('请输入用户名！');
				return;
			}
			if (isEmpty(values.password)) {
				ElMessage.warning('请输入密码！');
				return;
			}
			setLogining(true);
			setLoginText('正在登录中...');
			login(values)
				.then((result: Result<LoginData>) => {
					setLogining(false);
					ElNotification.closeAll();
					setLoginText('登录成功，正在进入系统...');
					const { data: _data } = result;

					setTimeout(() => {
						const { token, user } = _data;
						setUserToken();
						setSessionData(_data);
						setTokenInfo(token);
						dispatch(setUser(user));
						navigate('/chat');
					}, 500);
				})
				.catch(({ message }) => {
					if (isNotEmpty(message)) {
						ElMessage.error({ message: message, grouping: true });
					}
					setLogining(false);
					setLoginText('登录');
				});
		});
	}, [dispatch, formInstance, navigate]);

	const onLoginByPhone = useCallback(() => {
		formInstance1.validateFields().then(values => {
			setLogining(true);
			setLoginText('正在登录中...');
			loginByPhone({ type: 'phone', identifier: values.phoneNumber, code: values.code })
				.then((result: Result<LoginData>) => {
					setLogining(false);
					ElNotification.closeAll();
					setLoginText('登录成功，正在进入系统...');
					const { data } = result;

					setTimeout(() => {
						const { token, user } = data;
						setUserToken();
						setSessionData(data);
						setTokenInfo(token);
						dispatch(setUser(user));
						navigate('/chat');
					}, 500);
				})
				.catch(({ message }) => {
					if (isNotEmpty(message)) {
						ElMessage.error({ message: message, grouping: true });
					}
					setLogining(false);
					setLoginText('登录');
				});
		});
	}, [dispatch, formInstance1, navigate]);

	const sendCode = () => {
		formInstance1.validateFields(['phoneNumber']).then(user => {
			sendVerificationCode({ type: 'phone', identifier: user.phoneNumber })
				.then(msg => {
					ElMessage.success(msg);
					startTimeout();
				})
				.catch(msg => ElMessage.error(msg));
		});
	};

	const onEnter = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement>) => {
			if (event.key === 'Enter') {
				onLogin();
			}
		},
		[onLogin],
	);

	const onEnter1 = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement>) => {
			if (event.key === 'Enter') {
				onLoginByPhone();
			}
		},
		[onLoginByPhone],
	);

	return (
		<>
			<header className="ttn-layout-header">
				<div className="ttn-topbar" style={{ marginLeft: 15 }}>
					<div className="ttn-topbar-left" onClick={() => navigate('/chat')}>
						{
							<div className="ttn-welcome-text">
								<div>欢迎您</div>
							</div>
						}
					</div>
				</div>
			</header>
			<div className="ttn-login-container ttn-login-positon theme-default">
				<ElScrollbar>
					<div className="ttn-login-content">
						<div className="ttn-login-index-left">
							<ElCarousel height="100vh" trigger="click" indicatorPosition="none" arrow="never">
								{loginSlogon.map((item, index) => (
									<ElCarouselItem key={index}>
										<img src={require(`@/assets/images/login${index + 1}.webp`)} />
										<div>
											<p className="carousel__product-info">{item}</p>
										</div>
									</ElCarouselItem>
								))}
							</ElCarousel>
						</div>
						<div className="ttn-login-index-main">
							<ElTabs defaultActiveName="wechat" onTabChange={onTabChange}>
								<ElTabPane title="微信登录" name="wechat">
									<div className="login-panel__wechat">
										<p className="login-panel__wechat-info">
											<span className="login-panel__wechat-info-mark">微信</span>扫码关注公众号进行登录
										</p>
										<ElSkeleton animated visible={loading} variant="image" rows={0}>
											<div className="login-panel-wechat__container">
												{invalid ? (
													<div
														className="login-panel-wechat-render"
														onClick={() => {
															refresh();
															setInvalid(false);
															tryTimeRef.current = 0;
															if (timeRef.current) {
																clearInterval(timeRef.current);
															}
														}}
													>
														<p>{invalidText}</p>
														<p>点击刷新</p>
													</div>
												) : (
													<img src={`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${data.ticket}`} />
												)}
											</div>
										</ElSkeleton>
									</div>
								</ElTabPane>
								<ElTabPane title="账号登录" name="password">
									<ElForm labelPosition="top" className="ttn-login-form" form={formInstance} size="large">
										<ElForm.Item name="username" validateTrigger="onBlur">
											<ElInput placeholder="请输入用户名" prefix={<ElIcon name="user" />} onKeyDown={onEnter} autoFocus />
										</ElForm.Item>
										<ElForm.Item name="password">
											{({ value, onChange }) => (
												<ElInput
													type="password"
													placeholder="请输入密码"
													prefix={<ElIcon name="unlock-keyhole" />}
													showPassword
													onKeyDown={onEnter}
													value={value}
													onChange={onChange}
												/>
											)}
										</ElForm.Item>
										<ElForm.Item pure>
											{() => (
												<div className="auto-login">
													<ElLink type="primary">忘记密码</ElLink>
												</div>
											)}
										</ElForm.Item>
										<ElForm.Item pure center className="ttn-login-btn">
											<ElButton type="primary" block onClick={onLogin} loading={logining} disabled={!isAgree}>
												{loginText}
											</ElButton>
										</ElForm.Item>
									</ElForm>
								</ElTabPane>

								<ElTabPane title="短信登录" name="sms">
									<ElForm labelPosition="top" className="ttn-login-form" form={formInstance1} size="large" rules={rules}>
										<ElForm.Item name="phoneNumber" validateTrigger="onBlur">
											<ElInput
												placeholder="输入手机名"
												onKeyDown={onEnter1}
												autoFocus
												prepend={
													<ElSelect disabled value="+86" style={{ width: 100 }}>
														<ElOption value="+86">+86</ElOption>
													</ElSelect>
												}
											/>
										</ElForm.Item>
										<ElForm.Item name="code">
											{({ value, onChange }) => (
												<ElInput
													placeholder="输入验证码"
													suffix={
														<ElButton type="primary" link disabled={disabled} onClick={sendCode}>
															<span ref={buttonRef}>发送验证码</span>
														</ElButton>
													}
													showPassword
													onKeyDown={onEnter1}
													value={value}
													onChange={onChange}
												/>
											)}
										</ElForm.Item>
										<ElForm.Item pure>
											{() => (
												<>
													<div className="login-panel__register-legal-info">未注册的手机号验证后，将自动创建新账号</div>
												</>
											)}
										</ElForm.Item>
										<ElForm.Item pure center className="ttn-login-btn">
											<ElButton type="primary" block onClick={onLoginByPhone} loading={logining} disabled={!isAgree}>
												{loginText}
											</ElButton>
										</ElForm.Item>
									</ElForm>
								</ElTabPane>
							</ElTabs>
							<ElDivider></ElDivider>

							<div className="login-panel__center-footer">
								<ElButton type="primary" link onClick={() => navigate('/register')}>
									免费注册
								</ElButton>
							</div>
						</div>
					</div>
				</ElScrollbar>
			</div>

			<BindWechat ref={dialogRef} />
		</>
	);
};

export default memo(Login);
